const statusLabel = {
  title: 'Em Andamento',
  title1: 'Vencido',
  title2: 'Cancelado',
  title3: 'Concluído',
};

export default statusLabel;
